/** AppSync AWSJSON variables must be a JSON string, not a nested object. */
export function serializeAwsJson(value: Record<string, unknown>): string {
  return JSON.stringify(sanitizeForJson(value))
}

function sanitizeForJson(value: unknown): unknown {
  if (value === undefined) return undefined
  if (value === null) return null
  if (Array.isArray(value)) {
    return value.map(sanitizeForJson).filter((v) => v !== undefined)
  }
  if (typeof value === 'object') {
    const out: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      const next = sanitizeForJson(v)
      if (next !== undefined) out[k] = next
    }
    return out
  }
  return value
}
